import { render, staticRenderFns } from "./out_sourcing_order_process_edit.vue?vue&type=template&id=1636473c&scoped=true"
import script from "./out_sourcing_order_process_edit.vue?vue&type=script&lang=js"
export * from "./out_sourcing_order_process_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1636473c",
  null
  
)

export default component.exports